export default "__VITE_ASSET__Qpo9eOWi__"